import { render, staticRenderFns } from "./Commodity.vue?vue&type=template&id=25033a1a&scoped=true&"
import script from "./Commodity.vue?vue&type=script&lang=js&"
export * from "./Commodity.vue?vue&type=script&lang=js&"
import style0 from "./style.css?vue&type=style&index=0&id=25033a1a&prod&scoped=true&lang=css&"
import style1 from "./Commodity.vue?vue&type=style&index=1&id=25033a1a&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25033a1a",
  null
  
)

export default component.exports